import React, { useState } from "react";
import PropTypes from "prop-types";

import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";

import { makeStyles } from "@material-ui/core/styles";
import { styles } from "../../../utils/styles";

const useStyle = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));

const selectMapping = (selectValues, customClasses) =>
  selectValues.map(idx => (
    <MenuItem key={idx} value={idx} className={customClasses.menuItem}>
      {idx}
    </MenuItem>
  ));

const NativeSelect = ({ customStyle, isDesktop, value, defaultSelect, currentSelect, selectValues, onChange }) => {
  const [selectedValue, setSelectedValue] = useState(defaultSelect);
  const classes = useStyle();
  const customClasses = styles(customStyle);
  const buildedProps = {
    value: currentSelect !== null ? currentSelect : selectedValue,
    onChange: event => {
      onChange(event);
      setSelectedValue(event.target.value);
    },
  };
  return (
    <FormControl className={classes.formControl + " " + customClasses.formControl}>
      <InputLabel htmlFor={value}>{value}</InputLabel>
      {isDesktop ? (
        <Select {...buildedProps}>{selectMapping(selectValues, customClasses)}</Select>
      ) : (
        <NativeSelect {...buildedProps}>{selectMapping(selectValues, customClasses)} </NativeSelect>
      )}
    </FormControl>
  );
};

NativeSelect.defaultProps = {
  customStyle: null,
  isDesktop: true,
  defaultSelect: "",
  currentSelect: null,
};

NativeSelect.propTypes = {
  value: PropTypes.string.isRequired,
  defaultSelect: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  selectValues: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  customStyle: PropTypes.func,
  isDesktop: PropTypes.bool,
  currentSelect: PropTypes.any,
};

export default NativeSelect;
